import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  public constructor(
    private router: Router,
    private storageService: StorageService
  ) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    request = request.clone({
      setHeaders: {
        'X-Client-Id': environment.clientId,
        'X-Project-Id': environment.projectId,
      },
    });

    let currentUser: { token?: string } | null = null;
    if (localStorage.getItem('currentUser')) {
      currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
      if (currentUser?.token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${currentUser.token}`,
          },
        });
      }
    } else {
      let country = localStorage.getItem('CF-IPCountry');
      if (country) {
        country = JSON.parse(country) || '';
        if (country) {
          request = request.clone({
            setHeaders: {
              'CF-IPCountry': country,
            },
          });
        }
      }
    }

    const currentCardId: string | null = JSON.parse(
      localStorage.getItem('userCardId') ?? 'null'
    );
    if (currentCardId) {
      const cardTokenMap: { [key: string]: string } = JSON.parse(
        localStorage.getItem('cardTokenMap') ?? '{}'
      );
      const currentCardToken = cardTokenMap[currentCardId] ?? null;
      if (currentCardToken) {
        request = request.clone({
          setHeaders: {
            'X-Card-Token': currentCardToken,
          },
        });
      }
    }

    const userLanguage = JSON.parse(
      localStorage.getItem('language-selected') ?? `{}`
    );
    if (userLanguage?.id) {
      request = request.clone({
        setHeaders: {
          'X-Language-Id': userLanguage.id,
        },
      });
    }

    return next.handle(request).pipe(
      tap(
        () => {},
        (error: HttpErrorResponse) => {
          if (error['status'] == 401) {
            this.logout();
          } else if (
            error['status'] != 200 &&
            error['status'] != 401 &&
            error['status'] != 404
          ) {
            // this.router.navigate(["error"]);
          }
        }
      )
    );
  }

  public logout(): void {
    this.storageService.clearLocalStorage();
    this.router.navigate(['/']);
  }
}
